<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12">
          <h1>Vehicle Registration Report</h1>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
              <strong>Printed by</strong>
          </div>
          <div v-if="!plateLoaded" class="form-container">
              <LoadingSpinner />
          </div>
          <div v-if="plateLoaded" class="form-container">
            <b-row>
              <b-col cols="12" sm="4" md="4" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-bank p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Area</div>
                    <div class="h5 text-warning mb-0">{{regReport.area.area_name}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12" sm="4" md="4" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-building-o p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Site</div>
                    <div class="h5 text-warning mb-0">{{regReport.site.site_name}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12" sm="4" md="4" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">
                    <i class="fa fa-user p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">User</div>
                    <div class="h5 text-warning mb-0">{{regReport.printed_by_name}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
              <strong>Plate Details</strong>
          </div>
          <div v-if="!plateLoaded" class="form-container">
              <LoadingSpinner />
          </div>
          <div v-if="plateLoaded" class="form-container">
            <b-row>
              <b-col cols="12" sm="4" md="4" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-registered p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Registration</div>
                    <div class="h5 text-warning mb-0">{{regReport.registration_number}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12" sm="4" md="4" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-list-ol p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Job/WIP Number</div>
                    <div class="h5 text-warning mb-0">{{regReport.supplier_wip_number ? regReport.supplier_wip_number : "N/A"}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12" sm="4" md="4" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-calendar-o p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Date &amp; Time Printed</div>
                    <div class="h5 text-warning mb-0">{{regReport.printed_date}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="3" md="3" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-align-justify p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Slogan</div>
                    <div class="h5 text-warning mb-0">{{regReport.slogan || 'None'}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12" sm="3" md="3" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-envelope-o p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Post Code</div>
                    <div class="h5 text-warning mb-0">{{regReport.postcode || 'None'}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12" sm="3" md="3" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">
                    <i class="fa fa-print p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Printer Used</div>
                    <div class="h5 text-warning mb-0">{{regReport.printer_used}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
              <b-col cols="12" sm="3" md="3" >
                <b-card :no-body="true" footer-class="px-3 py-2">
                  <b-card-body class="p-3 clearfix">                      
                    <i class="fa fa-dashboard p-3 font-2xl mr-3 float-left"></i>
                    <div class="text-muted text-uppercase font-weight-bold font-xs">Amount Printed</div>
                    <div class="h5 text-warning mb-0">{{regReport.amount_printed}}</div>
                  </b-card-body>
                </b-card>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>
    </b-row>
    
    
  </div>
</template>

<script>
import LoadingSpinner from '../../components/loadingSpinner/LoadingSpinner';

const getHTTPHeaders = () => {
    let userObj = JSON.parse(localStorage.getItem('user'));
    let headerConfig = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Authorization': 'Bearer ' + userObj.token,
        }
    }
    return headerConfig;
}

const getRegReport = (($http, regValue) => {
    return new Promise((resolve, reject) => {
        let headersObj = getHTTPHeaders();
        $http.get("plates/vrm/search?vrm=" + regValue, headersObj)
            .then((response) => {
                resolve(response.data);
            })
            .catch ((err) => {
                console.error(err);
                reject(err);
            });
    });
});

export default {

  name: 'regreport',
  components: {
    LoadingSpinner: LoadingSpinner
  },
  data: function () {
    return {
      instantRegValue: '',
      noRegForReport: false,
      regParam: '',
      regReportFetchInProgress: false,
      regReport: {},
      plateLoaded: false,
    }
  },
  created() {
    this.$data.regParam = this.$route.params.reg;
    this.getRegReport();
  },
  methods: {
    getRegReport() {
      // reset flags
      this.$data.noRegForReport = false;
      this.$data.regReportFetchInProgress = true;
      getRegReport(this.$http, this.$data.regParam)
        .then((data) => {
          this.$data.regReport = data.plates[0];
          this.$data.regReport.amount_printed = data.plates.length;
          this.$data.plateLoaded = true;
        })
    }
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
